export default (props, vars) => !!props?.['footer'];
